export default {
  fulfillmentPacking: 'Комплектация',
  fulfillmentPackingCreate: 'Комплектация сборки',
  fulfillmentPackingStatus: 'Упаковка',
  fulfillmentPackedQuantity: 'Упаковано {packed} из {total}',
  fulfillmentPackingAlgorithm: 'Алгоритм выполнения задания по комплектации',
  fulfillmentPackingStepScan: 'Просканировать или ввести вручную штрихкод ФФ.',
  fulfillmentPackingStepCargo: 'Просканировать или ввести вручную штрихкод грузового места и нажать «Готово».',
  fulfillmentPackingStepPallet: 'Если необходимо сгруппировать картоны на паллету, выделите нужные картоны и нажмите «Добавить картон на паллету».',
  fulfillmentPackingStepComplete: 'После того как все посылки упакованы по коробкам, нажмите «Завершить задание». Отсканированные количества попадут в сборку и получат статус «Упакована».',
  fulfillmentPackingRetryHint: 'Не удалось подтвердить результат операции. Повторите её, прежде чем продолжать комплектацию.',
  fulfillmentPackingRetry: 'Повторить операцию',
  fulfillmentPackingRequestFailed: 'Не удалось выполнить запрос. Проверьте соединение и повторите попытку.',
  fulfillmentPackingAddToPallet: 'Добавить картон на паллету',
  fulfillmentPackingCompletionHint: 'Для завершения нужен хотя бы один заполненный картон. У заполненных картонов должны быть размер и штрихкод грузового места. Пустые картоны будут удалены.',
  fulfillmentPackingNoBoxes: 'Добавьте картон, чтобы начать сканирование.',
  fulfillmentPackingCargoRequired: 'Укажите штрихкод грузового места',
  fulfillmentPackingDetachPallet: 'Убрать картон с паллеты',
  fulfillmentPackingScan: 'Сканирование посылок',
  fulfillmentPackingBarcode: 'Штрихкод ФФ',
  fulfillmentPackingCargoBarcode: 'Штрихкод грузового места',
  fulfillmentPackingSummary: 'Использованные картоны',
  fulfillmentPackingBoxCount: 'Количество картонов',
  fulfillmentPackingBox: 'Картон',
  fulfillmentPackingRemoveUnit: 'Убрать одну единицу',
  fulfillmentPackingDeleteBox: 'Удалить картон и все отсканированные в него количества? Остатки инвентаря не изменятся.',
  fulfillmentPackingRefresh: 'Обновить',

  userManual: 'Руководство пользователя',
  downloadUserManual: 'Скачать руководство пользователя',
  currentManual: 'Текущий файл',
  newFile: 'Новый файл',
  noManualUploaded: 'Файл не загружен',
  fileNotSelected: 'Файл не выбран',
  // задания
  assignments: 'Задания',
  assignment: 'Задание',
  assignmentId: 'Номер задания',
  newAssignment: 'Новое задание',
  forParcel: 'для посылки ',
  forConsolidation: 'сборки',
  verifyHtsCodes: 'Проверка кодов ТН ВЭД',
  assignee: 'Исполнитель',
  creator: 'Постановщик',
  type: 'Тип',
  assignmentType: 'Тип задания',
  assignmentSource: 'Сборка/Посылка',
  attachFile: 'Прикрепить файл',
  selectFile: 'Выбрать файл',
  selectAnotherFile: 'Выбрать другой файл',
  selectFiles: 'Выбрать файл(ы)',
  selectAnotherFiles: 'Выбрать другой файл(ы)',
  comment: 'Комментарий',
  coomentOptional: 'Комментарий (опционально)',
  sendComment: 'Отправить',
  notAssigned: 'не назначен',
  startExecution: 'Начать выполнение',
  completeExecution: 'Завершить выполнение',
  addedStatus: 'добавил(а) статус',
  wrote: 'написал(а)',
  goToConsolidation: 'Перейти к Cборке',
  goToTask: 'Перейти к заданию',
  addComment: 'Добавить комментарий',
  assignmentCommentHelperText: 'Укажите дополнительный комментарий к заданию (опционально)',
  assignmentCancel: 'Отменить задание',
  areYouSureCancelAssignment: 'Вы уверены, что хотите хотите отменить задание',
  parcelsStatusWillBeChanged: 'Статус посылок будет изменен',
  // проверка ТН ВЭД
  listOfHtsCodesToCheck: 'Список кодов ТН ВЭД для проверки',
  goodsAreGroupedByHtsCodes: 'Все товары из Сборки сгруппированы по кодам ТН ВЭД',
  goodsAreAllowedByDefault: 'По умолчанию все коды (товары) считаются разрешенными (выделены зеленым)',
  howToMarkAsForbidden: 'Чтобы отметить, что код или товар являются запрещенными нажмите',
  howToMarkAsAllowed: 'Чтобы отметить, что код или товар являются разрешенными нажмите',
  howToAddComment: 'Чтобы добавить комментарий для кода или товара нажмите',
  markAsForbidden: 'Отметить как запрещенный',
  markAsAllowed: 'Отметить как разрешенный',
  quantityOfGoods: 'Количество товаров',
  pricePerGood: 'Стоимость одного товара',
  howToCompleteHtsCheck: 'После того как проверка всех кодов (товаров) завершена нажимите кнопку',
  verificationHtsCodeResult: 'Результаты проверки',
  // упаковка
  done: 'Готово',
  box: 'Картон',
  addBox: 'Добавить картон',
  addPallet: 'Добавить паллету',
  addToPallet: 'Добавить картон на паллету',
  boxes: 'Картоны',
  changeBoxSize: 'Изменить габариты картона',
  pallets: 'Паллеты',
  pallet: 'Паллета',
  packAssignmentAlgorithm: 'Алгоритм выполнения задания по упаковке',
  addBoxTask: 'Добавить картон (коробку) в которую будут добавляться посылки',
  addParcelTask: 'Нажать кнопку "Добавить посылку"',
  inputParcelCode: 'Просканировать или ввести вручную штрихкод посылки и нажать "Готово"',
  addPalletTask: 'Если необходимо сгрупировать картоны на паллету выделите нужные картоны и нажмите "Добавить картон на паллету"',
  completePackTask: 'После того как все посылки упакованы по коробкам нажмите "Завершить задание". Все посылки получат статус ',
  deleteBox: 'Удалить картон',
  deletePallet: 'Удалить паллету',
  confirmDeleteBox: 'Вы уверены, что хотите удалить картон?',
  confirmDeletePallet: 'Вы уверены, что хотите удалить паллету?',
  packCompleteBtnMessage: 'Упакованы не все посылки',
  packCompleteBtnMessageBoxesRequireSize: 'Для завершения упаковки необходимо указать размеры всех картонов, не добавленных на паллету',
  boxQuantity: 'Кол-во картонов',
  customPalletSize: 'Ввести габариты',
  changePalletSize: 'Изменить габариты паллеты',
  boxCount: 'Кол-во картонов',
  // Поиск посылки
  searchParcel: 'Поиск посылки',
  searchParcelInfo: 'Найдите посылку на складе',
  searchParcelCodeInfo: 'Укажите штрихкод посылки которую нужно найти',
  notFound: 'не найдена',
  parcelWithCode: 'Посылка с штрихкодом',
  parcelFound: 'Посылка найдена',
  parcelNotFound: 'Посылка не найдена',
  found: 'найдена',
  awaitingConfirmation: 'Ожидает подтверждения',
  searchParcelPhotoInfo: 'Для завершения задания необходимо приложить фотографии посылки',
  assignmentAlreadyExist: 'Задание для одной или нескольких посылок/сборок уже назначено или выполнено',
  areYouSureNewAssignment: 'Вы уверены, что хотите добавить новое',
  findParcelAndScanCode: 'Найти посылку на складе и ввести ее штрихкод в поле',
  takePhotoIfFind: 'Сделать фотографии посылки (если посылка найдена)',
  completeAssignment: 'Завершить выполнение',
  openParcel: 'Вскрыть посылку',
  parcelOpened: 'Посылка вскрыта',
  openParcelCodeInfo: 'Укажите штрихкод посылки которую нужно вскрыть',
  findParcelOnWarehouse: 'Найти посылку на складе',
  takePhotosOfTheOpenedParcel: 'Сделать фото содержимого посылки',
  openParcelAssignmentPhotoHelperText: 'Для завершения задания необходимо приложить фотографии содержимого посылки',
  // Произвольное задание
  arbitrary: 'Произвольное',
  removeConsolidationFromOrder: 'Убрать сборку из заказа',
  arbitraryInfo: 'Создайте задание с произвольными полями',
  linkedParcels: 'Прикрепленные посылки',
  linkParcel: 'Привязать посылку',
  linkConsolidation: 'Привязать сборку',
  connectedConsolidations: 'Прикрепленные сборки',
  task: 'Задание',
  arbitraryAlgorithmPerformTask: 'Выполнить задание в соответствии с его описанием',
  // Изменить штрихкод/Переклеить наклейку
  parcelCodeMatch: 'Штрихкоды совпадают',
  parcelCodeDoesNotMatch: 'Штрихкоды не совпадают',
  changeLabel: 'Замена штрихкода (этикетки)',
  parcelNewLabel: 'Новая этикетка',
  oldParcelCode: 'Старый штрихкод',
  newParcelCode: 'Новый штрихкод',
  labelReplaced: 'Этикетка приклеена',
  labelReplacedHelperText: 'Поставьте отметку ниже, чтобы указать что новая этикетка была приклеена',
  label: 'Этикетка',
  parcelCodeUpdated: 'Штрихкод обновлен',
  parcelCodeDoesNotUpdated: 'Штрихкод не обновлен',
  scanNewParcelCode: 'Сканировать новый штрихкод',
  actionAlgorithm: 'Алгоритм выполнения',
  downloadAndPrintNewLabel: 'Скачать и распечатать новую этикетку',
  replaceOldLabel: 'Приклеить новую этикетку',
  checkboxCheck: 'Поставить отметку о том, что этикета была приклеена',
  inputNewParcelCodeOr: 'Ввести штрихкод новой этикетки в поле',
  scanNewParcelCodeFor: 'Нажать «Проверить», чтобы убедиться, что введенный штрихкод совпадает с указанным в задании',
  replaceFrom: 'Заменить с ',
  replaceOn: 'на',

  // доставки
  delivery: 'Доставка',
  consolidationDelivery: 'Доставка сборки',
  deliveryHelperText: 'Информация о получателе',
  deliveryAddress: 'Адрес доставки',
  deliveryService: 'Служба доставки',
  deliveryServices: 'Службы доставки',
  deliveryServiceName: 'Служба доставки',
  newDeliveryService: 'Новая служба доставки',
  editDeliveryService: 'Изменить службу доставки',
  // отправки
  receipt: 'Отправка',
  receipts: 'Отправки',
  receiptNumber: 'Номер отправки',
  receiptPhoto: 'Фото при принятии',
  newReceipt: 'Новая отправка',
  clientLabel: 'Маркировка',
  clientLabelHelperText: 'Загрузите фото накладной или этикетки курьерской службы, по которому можно определить какому клиенту принадлежит данная отправка',
  receiptPhotoHelperText: 'Загрузите фото накладной или этикетки курьерской службы, фото самой упаковки, а также фото на которых видна клиентская маркировка (если имеется)',
  noClientLabelHelperText: 'Поставьте отметку ниже если маркировка отсутствует и принадлежность отправки к конкретному клиенту была определена каким-либо иным образом',
  withLabel: 'Присутствует',
  withoutLabel: 'Отсутствует',
  noClientLabel: 'Маркировка клиента отсутствует',
  counterpartyHelperText: 'Выберите клиента из списка ниже',
  manifestCounterpartyHelperText: 'Выберите клиента для которого вы загружаете манифест',
  attention: 'Внимание',
  receiptAlreadyExist: 'Отправка с таким трекинг кодом уже существует',
  // посылки
  parcels: 'Посылки',
  parcelsDativePlural: '0 посылок | {n} посылку | {n} посылки | {n} посылок',
  allParcels: 'Все посылки',
  parcelCount: 'Кол-во посылок, шт',
  createParcel: 'Добавить посылку',
  addParcel: 'Добавить посылку',
  parcel: 'Посылка',
  addParcels: 'Добавить посылки',
  parcelsToAdd: 'Посылки для добавления',
  parcelBarcodesColumn: 'Штрихкоды посылок',
  errors: 'Ошибки',
  addParcelsByList: 'Добавить посылки из списка',
  addByHand: 'Добавить вручную',
  newParcel: 'Новая посылка',
  parcelCode: 'Штрихкод',
  parcelAlreadyExist: 'Посылка с таким штрихкодом уже существует',
  areYouSureCreate: 'Вы уверены, что хотите создать еще одну',
  parcelInOrder: 'Посылка добавлена в заказ',
  parcelParameters: 'Параметры посылки',
  resetParcelStatus: 'Сбросить статус посылки',
  // манифесты
  uploadManifest: 'Загрузить манифест',
  manifestProcessed: 'Манифест обработан',
  manifestProcessedTooltip: 'Манифест обработан успешно, проверьте результаты перед сохранением',
  manifestProcessingResult: 'Результат обработки манифеста',
  parcelsProcessedSuccessfully: 'Посылки обновлены',
  parcelsProcessedSuccessfullyHelperText: 'Информация о товарах в посылках добавлена (обновлена) в системе',
  parcelsFound: 'Посылки найдены в системе',
  parcelsFoundHelperText: 'После нажатия "Сохранить" информация о товарах для этих посылок будет записана в системе',
  parcelsProcessingErrors: 'Посылки с предупреждениями',
  parcelsProcessingErrorsHelperText: 'При обработке этих посылок обнаружены некоторые несоответствия',
  parcelsNotFound: 'Посылки не найдены в системе',
  parcelsNotFoundHelperText: 'Штрихкоды некоторых посылок из манифеста не были найдены в системе',
  parcelsHaveGoods: 'Информация о посылках уже есть в системе',
  parcelsHaveGoodsHelperText: 'Можно обновить информацию о посылках в системе или оставить их без изменений (по умолчанию)',
  parcelsWithSimilarCode: 'Посылки с одинаковыми штрихкодами',
  parcelsWithSimilarCodeHelperText: 'Некоторые штрихкоды посылок в системе повторяются',
  parcelsWithSimilarCodeSelectHelperText: 'Выберите нужную посылку для каждого кода',
  duplicates: 'дубликатов',
  hasGoods: 'Есть товары',
  inOrder: 'В заказе',
  notInConsolidation: 'Не в сборке',
  // консолидации
  computationsWeight: 'Расчетный вес',
  consolidationNumber: 'Номер сборки',
  consolidation: 'Сборка',
  consolidations: 'Сборки',
  newConsolidation: 'Новая сборка',
  createConsolidation: 'Создать сборку',
  setReturnConsolidation: 'Информация о сборке на возврат',
  consolidationName: 'Название сборки',
  consolidationsHelperText: 'Из посылок находящихся на складе можно формировать "Сборки". Формирование сборки является является обязательным условием для создания заказа в TROL',
  consolidationsNameHelperText: 'Для упрощения дальнейшей работы со сборкой требуется указать название (комментарий)',
  consolidationId: 'ID сборки',
  consolidationIdHelperText: 'Каждой сборке при создании будет присвоен уникальный идентификатор, который будет использован для связи с заказами в TROL',
  consolidationGoodsPrice: 'Стоимость товаров, €',
  parcelCodeExistsInConsolidation: 'Посылка с таким штрихкодом уже добавлена в сборку',
  consolidationStatus: {
    new: 'Новая',
    ordered: 'Сформирована',
    inProgress: 'Формируется',
    packing: 'Упаковывается',
    packed: 'Упакована',
  },
  consolidationAssignmentListHelperText: 'Список заданий связанных со сборкой',
  linkedConsolidations: 'Связанные сборки',
  linkedConsolidationsList: 'Список связанных сборок',
  linkConsolidations: 'Связать сборки',
  link: 'Связать',
  TROLInformationWillNOTBeUpdated: 'Информация в TROL НЕ обновится',
  resetParcelStatusWarning: 'Статус посылки будет сброшен на Хранение, а также она будет удалена из сборок и связанных с ней заданий.',
  // группы пользователей
  userGroup: 'Группа пользователей',
  userGroups: 'Группы пользователей',
  newUserGroup: 'Новая группа пользователей',
  userGroupName: 'Название группы',
  userGroupHelperText: 'Введите название группы ниже - это название будет отображаться при создании создании заданий',
  userGroupEnabled: 'Группа включена (активна)',
  //
  goToTrolOrder: 'Перейти к заказу {id} в TROL',
  sendToVerify: 'Отправить на проверку',
  verify: 'Проверить',
  verificationTaskSent: 'Задание по проверке передано специалисту',
  startPacking: 'Начать упаковку',
  pack: 'Упаковка',
  packingTaskSent: 'Задание по сбору и упаковке передано специалисту',
  createOrder: 'Создать заказ',
  updateStatus: 'Обновить статус',
  targetStatus: 'Целевой статус',
  chooseConsolidation: 'Выберете сборку',
  chooseShipper: 'Выберете отправителя',
  addToConsolidation: 'Добавить в сборку',
  onlyAvailableForAddition: 'Только доступные для добавления',
  removeFromConsolidation: 'Удалить из сборки',
  moveToDifferentConsolidation: 'Перенести в другую сборку',
  consolidationsReturn: 'Возврат',
  consolidationsToReturn: 'Сборка на возврат',
  addConsolidationReturnInfo: 'Добавить информацию',
  consolidationReturnInfo: 'Информация о сборке на возврат',
  defaultReturnConsolidationCountry: 'Страна по умочанию для возвратных сборок',
  address: 'Адрес',
  index: 'Индекс',
  city: 'Город',
  country: 'Страна',
  consolidationReturnAddress: 'Адрес доставки',
  consolidationReturnAddressHelperText: 'Укажите адрес на какой будет совершен возврат сборки',
  consolidationReturnConsignee: 'Получатель',
  consolidationReturnContactPerson: 'Контактное лицо',
  consolidationReturnContactPhone: 'Контактный телефон',
  consolidationReturnComments: 'Комментарий к возврату',
  consolidationReturnCommentsHelperText: 'Добавте коментарий к сборке на возврат',
  consigneeHelperText: 'Укажите данные конечного получателя',
  contacts: 'Контакты',
  contactsHelperText: 'Укажите контакты для связи с получателем',
  true: 'Да',
  false: 'Нет',
  toolTipVerify: 'Для одной или нескольких посылок в сборке отсутствует инфо о товарах (коды ТН ВЭД)',
  toolTipForbidden: 'Для одной или нескольких посылок в сборке экспорт запрещен, либо посылка(и) не упакованы, либо привязаны сборки, по которым нельзя создать заказ',
  toolTipNotPacked: 'Одна или несколько посылок не прошли проверку (коды ТН ВЭД)',
  // заказы
  order: 'Заказ',
  orders: 'Заказы',
  // Контрагенты
  counterparty: 'Клиент',
  counterparties: 'Контрагенты',
  newCounterparty: 'Новый контрагент',
  mainCompany: 'Собственный контрагент',
  editCounterparty: 'Изменить контрагента',
  counterpartyAddress: 'Адрес',
  counterpartyPostCode: 'Почтовый индекс',
  counterpartyCountryCode: 'Код страны',
  weightFormula: 'Формула расчета веса',
  deliveryRate: 'Тариф доставки',
  deliveryRates: 'Тарифы доставки',
  deliveryRateWeight: 'Вес для тарифа доставки',
  regenerateDeliveryRateDetails: 'Пересоздать детализацию',
  deliveryRateWeightItems: {
    WEIGHT: 'Weight',
    VOLUME: 'Volume',
    MAX: 'Max.',
  },
  // Отправители
  shippers: 'Отправители',
  shipperPostCode: 'Почтовый код отправителя',
  shipperCountryCode: 'Код страны отправителя',
  // Дополнительные настройки
  AdditionalSettingsList: 'Дополнительные настройки',
  parcelWarehouseStorageTime: 'Срок хранения посылок на складе (в часах)',
  changeWarehouseStorageTimeEdit: 'Изменить срок хранения посылок на складе',
  changeSettings: 'Изменить настройки',
  // Доболнительные компоненты
  returnBackToList: 'Вернуться к списку',
  returnBackToReceipt: 'Вернуться к отправке',
  returnToConsolidation: 'Вернуться к сборке',
  // Статистика
  statistics: 'Статистика',
  ConsolidationStatisticsTitle: 'Сборки (и Заказы)',
  GoodsTitle: 'Товары',
  Total: 'Всего',
  totalVolumeM3: 'Общий объем, м³',
  averageVolumeM3: 'Средний объем, м³',
  totalWeightKg: 'Общий вес, кг',
  averageWeightKg: 'Средний вес, кг',
  withoutMarking: 'Без маркировки',
  averageInMonth: 'В среднем в месяц',
  inOneReceipt: 'В одной отправке',
  inOneConsolidation: 'В одной сборке',
  lengthWeightHeight: 'Длинна, см     Ширина, см     Высота, см',
  TotalProcessingTime: 'Общее время обработки (дней)',
  AverageProcessingTime: 'Среднее время обработки (чч:мм:сс)',
  itemCount: 'количество',
  minProductValue: 'Мин. цена',
  maxProductValue: 'Макс. цена',
  avgProductValue: 'Макс. цена',
  totalProductValueSum: 'Общая стоимость',
  averageProductValue: 'Средняя цена',
  maxParcelsInGoods: 'Макс. в посылке',
  avgConsolidationProductValue: 'Средняя стоимость товаров* в сборке',
  medianTimeBetweenAssemblyAndOrder: 'Медианное время между созданием сборки и заказа (чч:мм:сс)\n',
  // ---
  barcodeCopied: 'Штрих-код отсканирован',
  failedToCopyBarcode: 'Не удалось отсканировать штрих-код',
  copy: 'Копировать',
  developerDetails: 'Детали разработчика',
  edit: 'Редактировать',
  dateExpired: 'Просрочена',
  parcelProcessingTimeExpiredTooltip: 'Превышено время хранения посылки на складе',
  update: 'Обновить',
  ignore: 'Игнорировать',
  action: 'Действие',
  editMenuButton: 'Редактировать',
  goTo: 'Перейти',
  showDisabled: 'Показать отключенные',
  hide: 'Скрыть',
  apply: 'Применить',
  createdTimestamp: 'Принято',
  currentStatusCreatedTimestamp: 'Обработано',
  enabledShort: 'Вкл',
  saved: 'Сохранено',
  save: 'Сохранить',
  objectName: 'Название',
  loginRequired: 'Требуется авторизация',
  setStatus: 'Установить статус',
  saveAndAddAnother: 'Сохранить и добавить еще',
  actions: 'Действия',
  addTask: 'Добавить задание',
  export: 'Экспорт',
  invoice: 'Инвойс',
  baseRate: 'Базовая ставка',
  reportGeneration: 'Генерация отчета',
  fulfillmentEnabled: 'Фулфилмент (инвентарь)',
  pieces: 'шт.',
  users: 'Пользователи',
  addUser: 'Добавить пользователя',
  awaitingProcessing: 'Ожидает обработки',
  quickSearch: 'Поиск',
  trackingCode: 'Трекинг код',
  created: 'Добавлено',
  received: 'Принято',
  create: 'Добавить',
  add: 'Добавить',
  added: 'Добавлено',
  parcelAdded: 'Посылка добавлена',
  allParcelsScanned: 'Все посылки отсканированы',
  delete: 'Удалить',
  accepted: 'Ожидает обработки',
  processing: 'Обрабатывается',
  processed: 'Обработано',
  markProcessed: 'Завершить обработку',
  filters: 'Фильтры',
  itemsPerPage: 'Отображать по',
  details: 'Подробнее',
  retryScan: 'Сканировать код',
  clickToCopyBarcode: 'Нажмите, чтобы скопировать штрихкод',
  copiedToClipboard: 'Штрихкод скопирован',
  copyFailed: 'Не удалось скопировать штрихкод',
  sizeAndWeight: 'Габариты и вес',
  sizeAndWeightHelperText: 'Все поля ниже обязательны к заполнению (можно вводить числа с разделителем)',
  weight: 'Вес, кг',
  weightKg: 'Вес, кг',
  kg: 'кг',
  width: 'Ширина, см',
  widthCm: 'Ширина, см',
  widthMm: 'Ширина, мм',
  height: 'Высота, см',
  heightCm: 'Высота, см',
  heightMm: 'Высота, мм',
  length: 'Длина, см',
  lengthCm: 'Длина, см',
  lengthMm: 'Длина, мм',
  dimensions: 'Габариты, см',
  status: 'Статус',
  currentStatusName: 'Статус',
  name: 'Имя',
  surname: 'Фамилия',
  orderDate: 'Дата заказа',
  parcelStatusTypes: 'Статусы посылок',
  newParcelStatusType: 'Новый статус посылки',
  default: 'По умолчанию',
  availableForClientApi: 'Доступен для API клиента',
  onlyAutomatically: 'Только автоматически',
  setWhen: 'Устанавливать при',
  notifications: 'Уведомления',
  changesLocked: 'Изменения заблокированы',
  setAutomatically: 'Устанавливается автоматически',
  parcelStatusType: 'Статус посылки',
  upload: 'Загрузить',
  attachFiles: 'Прикрепить файл(ы)',
  attachConsolidations: 'Связать сборку(и)',
  unbindConsolidation: 'Отвязать сборку',
  consolidationReady: 'Создание заказа разрешено',
  consolidationNotReady: 'Создание заказа запрещено',
  files: 'Файлы',
  filesHelperText: 'Манифест, фото и другие документы',
  receiptFilesHelperText: 'Документы и прочее',
  documents: 'Документы',
  trolApiKey: 'API ключ TROL',
  hasApiKey: 'Имеет API ключ',
  newApiKey: 'Новый API ключ',
  present: 'Присутствует',
  absent: 'Отсутствует',
  change: 'Изменить',
  cancel: 'Отмена',
  undo: 'Отменить',
  yes: 'Да',
  no: 'Нет',
  size: 'Размер',
  download: 'Скачать',
  deleted: 'Удалено',
  canceled: 'Отменено',
  onOrderCreation: 'При создании заказа',
  onHtsVerification: 'При проверке ТН ВЭД',
  onHtsAllowed: 'Экспорт разрешен',
  onHtsForbidden: 'Экспорт запрещен',
  setAsPacking: 'Упаковывается',
  setAsAwaitingToPacking: 'Ожидает упаковки',
  setAsPacked: 'Упакована',
  canLogin: 'Активен',
  isActive: 'Активность',
  active: 'Активен',
  inactive: 'Не активен',
  deactivated: 'Деактивирован',
  deactivatedAt: 'Дата деактивации',
  deactivateUser: 'Деактивировать пользователя',
  activateUser: 'Активировать пользователя',
  activateUserConfirmation: 'Вы уверены, что хотите активировать этого пользователя?',
  deactivateUserConfirmation: 'Вы уверены, что хотите деактивировать этого пользователя?',
  deactivateSelfConfirmation: 'Вы уверены, что хотите деактивировать свою учетную запись? Данное действие приведет к разлогированию Вас из системы и к невозможности дальнейшей авторизации',
  deactivateUserWarning: 'После деактивации пользователь больше не сможет войти в систему, его текущая сессия будет завершена.',
  accountDeactivated: 'Ваша учетная запись была деактивирована',
  activateUserToast: 'Пользователь активирован',
  deactivateUserToast: 'Пользователь деактивирован',
  newUser: 'Новый пользователь',
  editUser: 'Изменить пользователя',
  password: 'Пароль',
  repeatPassword: 'Повторите пароль',
  email: 'Email',
  sorting: 'Сортировка',
  barcode: 'Штрихкод',
  barcodeHelperText: 'Можно отсканировать с помощью камеры или добавить вручную ниже',
  delivered: 'Доставлено',
  deliveredHelperText: 'Выберите службу доставки из предложенных ниже',
  volume: 'Объем, м³',
  price: 'Стоимость, €',
  login: 'Войти',
  rowsSkipped: 'строк пропущено',
  noData: 'Нет записей',
  noAssignments: 'Здесь пока нет заданий',
  noConsolidations: 'Здесь пока нет связанных сборок',
  noDocuments: 'Здесь пока нет документов',
  noFiles: 'Здесь пока нет файлов',
  noParcels: 'Здесь пока нет посылок',
  noGoods: 'Здесь пока нет товаров',
  addGoods: 'Добавить товар',
  noResults: 'Записи не найдены',
  uploadAnotherPhoto: 'Загрузить еще фото',
  uploadPhoto: 'Загрузить фото',
  uploadNewLabelPhoto: 'Загрузить фото новой этикетки',
  photo: 'Фото',
  loadingData: 'Загрузка данных',
  search: 'Поиск',
  createdFrom: 'Создано с',
  addedFrom: 'Добавлено от',
  addedTo: 'Добавлено до',
  createdTo: 'Создано по',
  processedFrom: 'Обработано с',
  parcelsLeft: 'Осталось посылок',
  processedTo: 'Обработано по',
  receivedFrom: 'Принято с',
  receivedTo: 'Принято по',
  goToStartingPage: 'Перейти на начальную страницу',
  accessDenied: 'Доступ запрещен',
  today: 'Сегодня',
  admin: 'Админ',
  clear: 'Сбросить',
  close: 'Закрыть',
  remove: 'Удалить',
  selected: 'Выбрано',
  select: 'Выбрать',
  check: 'Проверить',
  description: 'Описание',
  warning: 'Предупреждение',
  example: 'Пример',
  findInSystem: 'Найти в системе',
  addByList: 'Добавить списком',
  htsCode: 'Код ТН ВЭД',
  total: 'Итого',
  totalForbidden: 'Итого запрещенных',
  totalAllowed: 'Итого разрешенных',
  descriptionRu: 'Наименование товара на Русском языке',
  descriptionEn: 'Наименование товара на Английском языке',
  goodsDescription: 'Наименование товара',
  shipper: 'Отправитель',
  consignee: 'Получатель (ФИО)',
  productQuantity: 'Кол-во товаров, шт',
  productUnitValue: 'Стоимость товара',
  productUnitValueConverted: 'Стоимость товара в €',
  declaredValueCurrency: 'Валюта',
  declaredValueCurrencyConverted: 'Валюта €',
  netWeightKg: 'Вес нетто (кг)',
  grossWeightKg: 'Вес Брутто(кг)',
  goodsWeightKg: 'Вес нетто/брутто, кг',
  processingResult: 'Результат обработки',
  selectedParcelsAddedToConsolidation: 'Выбранные посылки добавлены в Сборку',
  ignoreAll: 'Игнорировать все',
  replaceAll: 'Заменить все',
  selectedFile: 'Выбранный файл',
  process: 'Обработать',
  processManifest: 'Обработать манифест',
  replace: 'Заменить',
  allowed: 'Разрешено',
  forbidden: 'Запрещено',
  notAllowed: 'Не разрешено',
  noResutls: 'Нет результатов',
  addShipper: 'Добавить отправителя',
  shipperAddress: 'Адрес отправителя',
  newValue: 'Новое значение',
  apiErrors: {
    'Inventory is used in a fulfillment packing assignment.': 'Инвентарь используется в задании на комплектацию и не может быть удалён.',
    'Inventory must be restored before removing it from a consolidation.': 'Перед удалением инвентаря из сборки необходимо восстановить остаток.',
    'Parcel consolidation links changed. Retry the assignment.': 'Состав связанных сборок изменился. Повторите выполнение задания.',
    'Select exactly one consolidation and no preselected parcels.': 'Выберите одну сборку. Посылки добавляются сканированием в задании.',
    'Exactly one target consolidation is required.': 'Для комплектации необходимо выбрать одну сборку.',
    'Operation ID was already used with different data.': 'Эта операция уже выполнена с другими данными. Обновите страницу перед продолжением.',
    'Cargo barcode is already used by another carton.': 'Этот штрихкод грузового места уже используется у другого картона.',
    'Carton item not found.': 'Позиция в картоне не найдена. Обновите данные задания.',
    'Carton quantity has changed. Refresh before editing.': 'Количество в картоне изменилось. Обновите данные перед редактированием.',
    'Insufficient inventory remainder.': 'Недостаточно доступного остатка инвентаря.',
    'The assignment is not in progress.': 'Задание не находится в работе. Обновите страницу и проверьте его статус.',
    'Carton not found in this assignment.': 'Картон не найден в этом задании. Обновите данные.',
    'Inventory barcode not found or no remainder available.': 'Штрихкод ФФ не найден у контрагента сборки или доступный остаток закончился.',
    'Every carton must contain inventory and have a size and cargo barcode.': 'Добавьте хотя бы один заполненный картон. У всех заполненных картонов должны быть размер и штрихкод грузового места.',
    'Inventory has changed. Check scanned quantities.': 'Инвентарь изменился. Проверьте отсканированные количества и доступные остатки.',
    'Access denied.': 'Недостаточно прав для выполнения операции.',
    'A fulfillment consolidation with a counterparty is required.': 'Выберите фулфилмент-сборку с указанным контрагентом.',
    'The consolidation can no longer be changed.': 'Эту сборку больше нельзя изменять. Обновите страницу и проверьте её статус.',
    'This operation requires a fulfillment packing assignment.': 'Эта операция доступна только в задании на комплектацию фулфилмент-сборки.',
    'Use fulfillment packing actions to change these containers.': 'Изменяйте эти картоны и паллеты через задание «Комплектация».',
    'Inventory is already dispatched to this consolidation. Update its quantity instead.': 'Инвентарь уже добавлен в эту сборку. Измените количество в существующей позиции.',
    'Packed inventory cannot be removed from its consolidation.': 'Упакованный инвентарь нельзя удалить из сборки.',
    'Quantity cannot be less than the packed quantity.': 'Количество не может быть меньше уже упакованного количества.',
    'Cannot mix parcels from different counterparties in a fulfillment consolidation.': 'Нельзя добавлять инвентарь разных контрагентов в одну фулфилмент-сборку.',
    'The assignment cannot be started.': 'Нельзя начать задание в текущем статусе. Обновите страницу.',
    'A completed packing assignment cannot be canceled.': 'Завершённое задание на комплектацию нельзя отменить.',
    'Quantity must be a positive integer.': 'Количество должно быть положительным целым числом.',
    'Only inventory parcels can be dispatched.': 'Списание доступно только для инвентарных посылок.',
    'Dispatch is only allowed for fulfillment consolidations.': 'Списание инвентаря доступно только для фулфилмент-сборок.',

    'Validation Failed': 'Ошибка валидации',
    'Invalid credentials.': 'Неверные учетные данные.',
    'Consolidation already has an order.': 'Сборка уже имеет связанний заказ.',
    'Receipt has parcels.': 'Приемка имеет связанные посылки.',
    'This parcel is locked.': 'Изменение посылки запрещено.',
    'Parcel not found in consolidation.': 'Посылка не найдена в сборке.',
    'Parcel already added to consolidation.': 'Посылка уже добавлена в сборку.',
    'Parcel is locked.': 'Изменение посылки запрещено.',
    'Parcel not found.': 'Посылка не найдена.',
    'Cannot add parcels from different counterparties to one consolidation.': 'Нельзя добавить посылки разных контрагентов в одну сборку.',
    'Parcel and consolidation have different counterparties.': 'Посылка и сборка имеют разных контрагентов.',
    'Provided list has parcels from different counterparties.': 'Список содержит посылки разных контрагентов.',
    'Not all goods have been verified.': 'Не все товары проверены.',
    'Counterparty has no API key.': 'У контрагента отсутствует API ключ.',
    'Changes are blocked.': 'Изменения заблокированы.',
    'Multiple parcels with the same code.': 'Несколько посылок с одинаковым штрихкодом.',
    'No pack assignment found for consolidation.': 'Не найдено задание по упаковке для этой сборки',
    'There are parcels that are simultaneously in several consolidations.': 'Есть посылки, которые находятся одновременно в нескольких сборках.',
    'You need to write a task description': 'Необходимо составить описание задачи.',
    'Can not disable default delivery rate': 'Невозможно отключить тариф по умолчанию.',
    'Account is deactivated': 'Ваша учетная запись была деактивирована.',
    'Full authentication is required to access this resource.': 'Необходимо аутентификация в системе, чтобы получить доступ к ресурсу.',
    'Inventory parcels can only be added to fulfillment consolidations.': 'Инвентарные посылки можно добавлять только в фулфилмент-сборки.',
    'Only inventory parcels can be added to fulfillment consolidations.': 'В фулфилмент-сборку можно добавлять только инвентарные посылки.',
    'Cannot mix inventory and regular parcels in one consolidation.': 'Нельзя добавлять инвентарные и обычные посылки в одну сборку.',
    'Counterparty is required for inventory parcels without a receipt.': 'Укажите контрагента для инвентарной посылки без отправки.',
    'Counterparty is not enabled for fulfillment.': 'Контрагент не подключён к фулфилменту.',
    'Receipt counterparty does not match selected counterparty.': 'Контрагент отправки не совпадает с выбранным контрагентом.',
  },
  validation: {
    messages: {
      default: 'Ошибка валидации',
      'Quantity must be an integer.': 'Количество должно быть целым числом.',
      'Default rate must be set for report generation.': 'Для генерации отчета должен быть выбран тариф по умолчанию.',
      'This value should not be blank.': 'Это поле не может быть пустым.',
      'Passwords must match.': 'Пароли должны совпадать.',
      'At least one photo is required.': 'Необходимо добавить хотя бы одно фото.',
      'You must add at least one task.': 'Вы должны добавить хотя бы одну задачу.',
      'Error while creating order in TROL': 'Невозможно создать заказ. Обратитесь в службу поддержки.',
    },
  },
  removeParcels: 'Убрать посылки',
  removeParcelsFromConsolidation: 'Откат посылок из заказа',
  removeParcelsFromConsolidationTitle: 'Задание на откат посылок из сборки #{id}',
  removeParcelsFromConsolidationDescription: 'Необходимо убрать выбранные посылки из сборки и вернуть их на хранение.',
  selectParcelsForRemoval: 'Выбор посылок для отката',
  selectParcelsForRemovalInfo: 'Отметьте посылки, которые необходимо убрать из заказанной сборки.',
  parcelsToRollback: 'Посылки для отката',
  selectParcelsToContinue: 'Выберите хотя бы одну посылку для продолжения.',
  scanParcelsForRemoval: 'Сканирование посылок для отката',
  scanParcelsForRemovalInfo: 'Отсканируйте каждую посылку, чтобы подтвердить ее откат.',
  scannedParcels: 'Отсканированные посылки',
  parcelScannedSuccessfully: 'Посылка успешно отсканирована.',
  parcelsToRemove: 'Посылки для удаления',
  parcelsSelectedForRemoval: 'Посылки, которые будут удалены',
  removeParcel: 'Удалить посылку',
  parcelsRemovedFromConsolidation: 'Посылки удалены из сборки',
  parcelsRemovedMessage: 'Посылки убраны из сборки и находятся снова на хранении.',
  scanProgress: 'Отсканировано {scanned} из {total}',
  noParcelsToRemove: 'Нет посылок для удаления',
  failedToLoadTargets: 'Не удалось загрузить целевые посылки.',
  failedToLoadScannedParcels: 'Не удалось загрузить отсканированные посылки.',
  invalidParcelCode: 'Неверный штрихкод посылки.',
  noParcelsAvailable: 'Нет доступных посылок для выбора.',
  parcelsSelected: 'посылок выбрано',
  selectAtLeastOneParcel: 'Выберите хотя бы одну посылку.',
  selectedParcels: 'Выбранные посылки',
  consolidationIdNotFound: 'Не найден ID сборки',
  noParcelsAvailableForRemoval: 'Нет доступных посылок для удаления',
  failedToLoadParcels: 'Не удалось загрузить посылки',

  fulfillment: 'Фулфилмент',
  fulfillmentReturn: 'Фулфилмент возврат',
  fulfillmentInventory: 'Фулфилмент',
  receiptOptional: 'Отправка (необязательно)',
  fulfillmentReceiptOptionalHint: 'Привяжите к отправке, если товар пришёл через обычный поток. Иначе достаточно указать контрагента.',
  consolidationType: 'Тип сборки',
  consolidationTypeExcludeFulfillment: 'Все, кроме фулфилмент',
  consolidationTypeRegular: 'Обычная',
  consolidationTypeFulfillment: 'Фулфилмент',
  consolidationTypeFulfillmentReturn: 'Фулфилмент возврат',
  consolidationTypeAll: 'Все',
  newFulfillmentParcel: 'Новая инвентарная посылка',
  fulfillmentParcel: 'Инвентарная посылка',
  fulfillmentParcelData: 'Данные инвентарной посылки',
  editFulfillmentParcel: 'Редактировать инвентарную посылку',
  newFulfillmentConsolidation: 'Новая фулфилмент-сборка',
  acceptedAt: 'Дата приёмки',
  acceptedFrom: 'Приёмка от',
  acceptedTo: 'Приёмка до',
  inventoryAccepted: 'Принято',
  remainder: 'Остаток',
  editableRemainder: 'Остаток после',
  quantityPcs: 'Количество (шт.)',
  pcs: 'шт.',
  cm: 'см',
  dispatchHistory: 'История отгрузок',
  noDispatchHistory: 'Нет записей об отгрузках',
  dispatchDate: 'Дата отгрузки',
  dispatchActive: 'Активно',
  restored: 'Восстановлено',
  addInventoryParcel: 'Добавить инвентарную посылку',
  editQuantity: 'Изменить количество',
  confirmDeleteFulfillmentParcel: 'Вы уверены, что хотите удалить эту инвентарную посылку?',
  confirmDelete: 'Подтверждение удаления',
  cannotMixInventoryAndRegularParcels: 'Нельзя добавлять инвентарные и обычные посылки в одну сборку.',
  dispatchedQuantity: 'Добавлено',
  parcelAlreadyAddedToConsolidation: 'Посылка уже добавлена в сборку',
  inventoryParcelsAddViaFulfillment: 'Инвентарные посылки добавляйте в фулфилмент-сборку через раздел «Фулфилмент».',
  article: 'Артикул',
  deliveryServiceOptional: 'Служба доставки (необязательно)',
  fulfillmentParcelPhoto: 'Фото товара',
  fulfillmentParcelPhotoHelperText: 'Загрузите фото товара, упаковки или маркировки (если требуется)',
  inventoryStatus: {
    received: 'Принята',
    in_progress: 'Реализуется',
    archived: 'Реализована',
  },
  accessRoles: {
    accessRoles: 'Права доступа',
    ROLE_CONS_ORDERS: 'Создание консолидаций и заказов (клиент)', // create consolidations/orders
    ROLE_PARCELS_RECEIPTS: 'Создание отправок и посылок (сотрудник склада)', // create parcels/receipts
    ROLE_ADMIN: 'Просмотр разделов админ (администратор)', // access to admin chapters
    ROLE_CONSOLIDATION_FILES: 'Доступ к файлам консолидации',
    ROLE_VIEW_STATISTICS: 'Просмотр раздела статистики',
    ROLE_CHANGE_DELIVERY_RATE: 'Изменение тарифа доставки в сборках',
    ROLE_CONSOLIDATION_DELETE_FILES: 'Удаление файлов из сборок',
    ROLE_REMOVE_PARCELS_FROM_CONS: 'Откат посылок из сборки с заказом',
    ROLE_GOODS_EDIT: 'Добавление и редактирование товаров в посылках',
    ROLE_INVOICE: 'Генерация инвойса для сборки',
    ROLE_FULFILLMENT_VIEW: 'Просмотр фулфилмент-инвентаря',
    ROLE_FULFILLMENT_PARCEL_EDIT: 'Создание и редактирование инвентарных посылок',
    ROLE_FULFILLMENT_PARCEL_DELETE: 'Удаление инвентарных посылок',
    ROLE_FULFILLMENT_CONS_CREATE: 'Создание фулфилмент-сборок',
  },
  notificationTypes: {
    'parcels.daily-processed': 'Посылки обработаные за день',
    'parcels.assignment-created': 'Создание заданий',
    'parcels.assignment-complete': 'Завершение заданий',
    'parcels.assignment-canceled': 'Отмена заданий',
    'parcels.daily-expired': 'Просроченные посылки',
  },
  assignmentStatuses: {
    new: 'Ожидает выполнения',
    assigned: 'Назначен исполнитель',
    'in-progress': 'В работе',
    done: 'Выполнено',
    canceled: 'Отменено',
  },
  commentAddedSuccessfully: 'Комментарий успешно добавлен',
  assigneeOptionalHint: 'Для этого типа задания исполнитель не обязателен — можно оставить поле пустым.',
  $vuetify: {
    noDataText: 'Нет данных',
    badge: 'Значек',
    datePicker: {
      prevMonthAriaLabel: 'Предыдущий месяц',
      nextMonthAriaLabel: 'Следующий месяц',
      prevYearAriaLabel: 'Предыдущий год',
      nextYearAriaLabel: 'Следующий год',
    },
    dataTable: {
      sortBy: 'Сортировка',
      ariaLabel: {
        sortNone: 'Не сортировать',
        activateAscending: 'По возрастанию',
        activateDescending: 'По убыванию',
        sortAscending: 'По возрастанию',
      },
    },
    dataFooter: {
      pageText: '{0}-{1} из {2}',
      nextPage: 'Следующая страница',
      prevPage: 'Предыдущая страница',
      itemsPerPageText: 'Строк на странице:',
    },
    pagination: {
      ariaLabel: {
        page: 'Страница',
        next: 'Следующая',
        previous: 'Предыдущая',
        currentPage: 'Текущая страница',
        wrapper: 'Обертка',
      },
    },
  },
};
